import {INodeData} from "./INodeData";

export interface ITextData extends INodeData {
  textContent: string;
}